export type SignalTone = 'positive' | 'info' | 'warning' | 'urgent' | 'neutral';
export const STATUS_TERMS = {
  live: 'Live',
  urgent: 'Immediate attention',
  verified: 'Verified',
  warm: 'Warm intro',
} as const;

export function StatusSignal({ label, tone = 'neutral' }: { label: string; tone?: SignalTone }) {
  return <span className={`status-signal status-signal--${tone}`}><span aria-hidden="true" className="status-dot" />{label}</span>;
}
